var MainImage = () => import('~/components/atoms/Editorial/MainImage.vue');
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
export default {
  name: 'CardHorizontal',
  components: {
    MainImage,
    MdmLink
  },
  props: {
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      default: null
    },
    url: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: null
    },
    ratio: {
      type: String,
      default: '16:9'
    },
    description: {
      type: String,
      default: null
    },
    tracking: {
      type: Object,
      default: null
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  }
};